import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeBillerOfferStep } from '../../models/change-biller-offer-step.model';

@Component({
standalone: false,
  selector: 'app-dobry-prad-offer-dialog',
  styleUrls: ['./dobry-prad-offer-dialog.component.scss'],
  templateUrl: './dobry-prad-offer-dialog.component.html',
})
export class DobryPradOfferDialogComponent {
  public step: ChangeBillerOfferStep = ChangeBillerOfferStep.INFO;

  public offerStep = ChangeBillerOfferStep;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { customerBillerId: string }) {}
}
